import { Grid, Typography } from "@mui/material";

export function DialogInfoItem(props: {
  name: string;
  value: string | number;
  fontSize?: number;
}) {
  const { name, value, fontSize } = props;
  return (
    <Grid
      item
      xs={12}
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
    >
      <Typography fontSize={fontSize ?? 12}>{name}:</Typography>
      <Typography fontSize={fontSize ?? 12}>{value}</Typography>
    </Grid>
  );
}
